import { Note01Icon } from '@hugeicons/core-free-icons'
import { AnalyticsEmpty } from '@/components/shared/analytics/AnalyticsEmpty'
import { RaisedCard, CardHead } from '@/components/dashboard/analyticsTabs/TabPrimitives'
import type { FormIntentPage } from '@/lib/calculations/formsEmpty'
import { formatNumeric } from '@/lib/utils/stringUtils'

/**
 * Paper "Analytics · Clicks & forms · No forms detected": the Form submissions
 * card when no submission has ever reached the site in this range. The one
 * orange action connects a form tool; the line names a clicked form-like page
 * only when the clicks data has one.
 */
export function FormsNoFormsDetected({
  domain,
  periodNoun,
  formPage,
  onConnect,
}: {
  domain: string
  /** "this week" */
  periodNoun: string
  formPage: FormIntentPage | null
  /** Omitted where there is no Connectors page (share links) */
  onConnect?: () => void
}) {
  const lead = formPage
    ? `The ${formPage.page} page got ${formatNumeric(formPage.clicks)} ${formPage.clicks === 1 ? 'click' : 'clicks'} ${periodNoun}, but no submission reached us.`
    : `No form submission reached us ${periodNoun}.`
  return (
    <RaisedCard>
      <CardHead title="Form submissions" />
      <AnalyticsEmpty
        icon={Note01Icon}
        title={domain ? `No forms detected on ${domain}` : 'No forms detected'}
        description={`${lead} Without forms, funnels and tests can not use sign-ups or demo requests as goals.`}
      >
        <div className="mt-5 flex flex-wrap items-center justify-center gap-2">
          {onConnect && (
            <button
              type="button"
              onClick={onConnect}
              className="flex h-8 items-center rounded-lg bg-primary px-3 text-[13px] font-medium leading-4 text-primary-foreground transition-colors hover:bg-primary/90"
            >
              Connect a form tool
            </button>
          )}
          <span className="text-[13px] leading-4 text-muted-foreground">Typeform, Tally, JotForm or Webflow</span>
        </div>
      </AnalyticsEmpty>
    </RaisedCard>
  )
}
